import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import groupBy from 'lodash/groupBy';
import s from './Accordion.css';

class Accordion extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape),
    rows: PropTypes.number,
  };

  static defaultProps = {
    items: [],
    rows: 1,
  };

  state = {
    isShowed: {},
  };

  componentWillMount = () => {
    this.initKeys();
  };

  initKeys = () => {
    const isShowed = {};
    this.props.items.forEach(item => {
      isShowed[item.title] = true;
    });
    this.setState(isShowed);
  };

  toggle = title => {
    const { isShowed } = this.state;
    isShowed[title] = !isShowed[title];
    this.setState(isShowed);
  };

  render() {
    const { items, rows } = this.props;
    const { isShowed } = this.state;
    const rowsList = new Array(rows).fill(0);
    const colCount = Math.ceil(items.length / rows);
    const grouped = [];
    let i = 0;
    rowsList.forEach(() => {
      grouped.push({
        items: items.slice(i, colCount + i),
        key: i,
      });
      i += colCount;
    });
    return (
      <div className={s.root}>
        {grouped.map(columns =>
          <ul className={s.group} key={columns.key}>
            {columns.items.map(({ title, html }) =>
              <li className={s.p} key={title}>
                <div className={s.groupTitle}>
                  <span className={s.title}>
                    {title}
                  </span>
                  <div
                    className={cx(s.groupToggleBtn, {
                      [s.groupToggleOpened]: isShowed[title],
                      [s.groupToggleClosed]: !isShowed[title],
                    })}
                    onClick={() => this.toggle(title)}
                  />
                </div>

                <div
                  className={cx(s.details, {
                    [s.detailsHidden]: !isShowed[title],
                  })}
                  dangerouslySetInnerHTML={{ __html: html }}
                />
              </li>,
            )}
          </ul>,
        )}
      </div>
    );
  }
}

export default withStyles(s)(Accordion);



// WEBPACK FOOTER //
// ./src/shared/components/Accordion/Accordion.js